var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row top-organization"},[_c('div',{staticClass:"col-md-4"},[_c('span',[_vm._v("Оформлена: "+_vm._s(_vm.applicant.name ? _vm.applicant.name : ' '))])]),_c('div',{staticClass:"col-md-4"},[_vm._v(" Email: "),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.applicant.email
          ? '<a href=' + 'mailto:' + _vm.applicant.email + '>' + _vm.applicant.email + '</a>'
          : '&nbsp;'
      )}})]),_c('div',{staticClass:"col-md-4"},[_vm._v(" Телефон: "),_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.applicant.phone
          ? '<a href=' + 'tel:' + _vm.applicant.phone + '>' + _vm.applicant.phone + '</a>'
          : '&nbsp;'
      )}})])])}
var staticRenderFns = []

export { render, staticRenderFns }